<div #recorderWrapper class="recorder-wrapper">
  <div class="recorder-header" *ngIf="!isMobile">
    <button class="record-close" (click)="closeRecorder()">X</button>
  </div>
  <div class="actions">
    <div class="top-actions">
      <div class="top-selects">
        <div class="text-area">
          <div [class.showQuestions]="isQuestions" class="questions-list">
            <p style="text-decoration: underline; margin-bottom: 1rem">
              Pitch Topics
            </p>
            <ul *ngIf="pitchcardType === 'service'">
              <li>
                <p contenteditable="true">Name</p>
              </li>
              <li>
                <p contenteditable="true">What you do (very basic)</p>
              </li>
              <li>
                <p contenteditable="true">Background</p>
              </li>
              <li>
                <p contenteditable="true">Family</p>
              </li>
              <li>
                <p contenteditable="true">Unique Hobbies/Interests</p>
              </li>
              <li>
                <p contenteditable="true">What sets you apart</p>
              </li>
              <li>
                <p contenteditable="true">Your cause or mission</p>
              </li>
              <li>
                <p contenteditable="true">Call to action</p>
              </li>
            </ul>
            <ul
              *ngIf="pitchcardType === 'basic' || pitchcardType === 'employee'"
            >
              <li>
                <p contenteditable="true">Name</p>
              </li>
              <li>
                <p contenteditable="true">What you do (very basic)</p>
              </li>
              <li>
                <p contenteditable="true">Background</p>
              </li>
              <li>
                <p contenteditable="true">Family</p>
              </li>
              <li>
                <p contenteditable="true">Unique Hobbies/Interests</p>
              </li>
              <li>
                <p contenteditable="true">What sets you apart</p>
              </li>
              <li>
                <p contenteditable="true">
                  Customer concerns with your industry
                </p>
              </li>
              <li>
                <p contenteditable="true">How you resolve those concerns</p>
              </li>
              <li>
                <p contenteditable="true">Call to action</p>
              </li>
            </ul>
            <ul *ngIf="pitchcardType === 'resume'">
              <li>
                <p contenteditable="true">Name</p>
              </li>
              <li>
                <p contenteditable="true">Background</p>
              </li>
              <li>
                <p contenteditable="true">Family</p>
              </li>
              <li>
                <p contenteditable="true">Hobbies/Interests</p>
              </li>
              <li>
                <p contenteditable="true">Passions</p>
              </li>
              <li>
                <p contenteditable="true">Skills/Talents</p>
              </li>
              <li>
                <p contenteditable="true">Motivations</p>
              </li>
              <li>
                <p contenteditable="true">I’m looking for...</p>
              </li>
            </ul>
            <ul *ngIf="pitchcardType === 'job'">
              <li>
                <p contenteditable="true">Company name</p>
              </li>
              <li>
                <p contenteditable="true">What you do (very basic)</p>
              </li>
              <li>
                <p contenteditable="true">Position details</p>
              </li>
              <li>
                <p contenteditable="true">What sets you apart</p>
              </li>
              <li>
                <p contenteditable="true">Company culture/atmosphere</p>
              </li>
              <li>
                <p contenteditable="true">Your cause or mission</p>
              </li>
              <li>
                <p contenteditable="true">Call to action</p>
              </li>
            </ul>
            <ul *ngIf="pitchcardType === 'employerPortal'">
              <li>
                <p contenteditable="true">Company name</p>
              </li>
              <li>
                <p contenteditable="true">What you do (very basic)</p>
              </li>
              <li>
                <p contenteditable="true">Company culture/atmosphere</p>
              </li>
              <li>
                <p contenteditable="true">What sets you apart</p>
              </li>
              <li>
                <p contenteditable="true">Company goals</p>
              </li>
              <li>
                <p contenteditable="true">Your cause or mission</p>
              </li>
              <li>
                <p contenteditable="true">Call to action</p>
              </li>
            </ul>
          </div>
          <div [class.showTeleprompter]="isTeleprompter" class="teleprompter">
            <div class="teleprompter-сontainer" [ngStyle]="{'top.px': top, 'left.px': left}" #textareaContainer>
              <textarea
                class="text-center"
                [readonly]="!isTeleprompterEditing"
                [ngClass]="{ 'cursor-default': !isTeleprompterEditing }"
                #textarea
                [(ngModel)]="teleprompter"
                [ngStyle]="{'width.px': width, 'height.px': height}"
                [style.font-size.px]="fontSize"
              ></textarea>

              <div class="edit-handle cursor-pointer" [ngClass]="{'hasScroll': isTeleprompterHasScroll && !isMobile}"
                   (click)="toggleTeleprompterEdit()">
                <img *ngIf="!isTeleprompterEditing" src="assets/images/icon-edit-white.svg" alt="">
                <img *ngIf="isTeleprompterEditing" src="assets/images/teleprompter/icon-edit-finish.svg" alt="">
              </div>

              <div class="drag-handle" (mousedown)="startDrag($event)" (touchstart)="startDrag($event)">
                <img src="assets/images/teleprompter/icon-arrow-move.svg" alt="">
              </div>

              <div class="resize-handle-right" *ngIf="!isTeleprompterEditing"
                   (mousedown)="startResize($event, 'right')"
                   (touchstart)="startResize($event, 'right')">
                <img src="assets/images/teleprompter/icon-arrow-horizontal.svg" alt="">
              </div>

              <div class="resize-handle-bottom" *ngIf="!isTeleprompterEditing"
                   (mousedown)="startResize($event, 'bottom')"
                   (touchstart)="startResize($event, 'bottom')">
                <img src="assets/images/teleprompter/icon-arrow-vertical.svg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div [class.les-time-left]="isTenSecondsLeft" class="top-timer">
        <countdown
          #countdown
          (event)="countdownTimer($event)"
          [config]="{
            leftTime: countdownTopLeftTime,
            demand: true,
            format: 'ss',
            notify: [10]
          }"
        ></countdown>
      </div>
    </div>
    <div [class.hide-bacground]="isRecording" class="bottom-actions">
      <div class="absolute d-grid mobile-help-menu" *ngIf="isMobile">
        <button class="help-btn" (click)="toggleTeleprompter()">
          <img width="45" height="45"
               [ngSrc]="isTeleprompter ? 'assets/images/teleprompter/icon-teleprompter-active.svg': 'assets/images/teleprompter/icon-teleprompter.svg'"
               alt="teleprompter" />
          <span class="pt-1">Teleprompter</span>
        </button>
        <button class="help-btn" (click)="toggleQuestions()">
          <img width="45" height="45"
               [ngSrc]="isQuestions ? 'assets/images/teleprompter/icon-tips-active.svg' : 'assets/images/teleprompter/icon-tips.svg'"
               alt="Questions" />
          <span class="pt-1">Pitch Tips</span>
        </button>
      </div>
      <div [ngClass]="{
      flex: !isMobile,
      'justify-content-center': !isMobile,
      'd-grid': isMobile,
      'justify-content-between': isMobile,
      'height100': isMobile,
      'm-auto': isMobile
      }" class="align-items-center">
        <div *ngIf="isMobile && !isRecorded" [ngClass]="{'mr-2': !isMobile}" class="action-container flex justify-content-center">
          <button (click)="toggleCamera()" [disabled]="isRecorded">
            <img src="assets/images/teleprompter/icon-rotate-camera.svg" alt="">
          </button>
        </div>
        <div *ngIf="isTeleprompter && isMobile" class="action-container" [ngClass]="{'mr-2': !isMobile}">
          <div class="flex align-items-baseline">
            <button (click)="changeTeleprompterFontSize('decrease')">-</button>
            <img width="31" height="24" ngSrc="assets/images/teleprompter/icon-size-text.svg" alt="">
            <button (click)="changeTeleprompterFontSize('increase')">+</button>
          </div>
          <span class="action-title">Text Size</span>
        </div>
        <ng-container *ngIf="!isMobile">
          <button class="help-btn" (click)="toggleTeleprompter()">
            <img width="45" height="45"
                 [ngSrc]="isTeleprompter ? 'assets/images/teleprompter/icon-teleprompter-active.svg': 'assets/images/teleprompter/icon-teleprompter.svg'"
                 alt="teleprompter" />
            <span class="pt-1">Teleprompter</span>
          </button>
          <button class="help-btn" (click)="toggleQuestions()">
            <img width="45" height="45"
                 [ngSrc]="isQuestions ? 'assets/images/teleprompter/icon-tips-active.svg' : 'assets/images/teleprompter/icon-tips.svg'"
                 alt="Questions" />
            <span class="pt-1">Pitch Tips</span>
          </button>
        </ng-container>
      </div>
      <div class="record-btn-container justify-content-center align-items-center">
        <button
          (click)="isRecording ? stopRecording() : startBeforeRecord()"
          [disabled]="isActiveCoundown"
          [ngClass]="{
          isRecording: isRecording,
          isRecorded: isRecorded,
          countDownActive: isActiveCoundown
        }"
          class="record-btn"
        >
          <span *ngIf="isRecorded && !isMobile">RETAKE</span>
          <span *ngIf="isRecorded && isMobile">Retake</span>
        </button>
        <button
          (click)="togglePlayer()"
          *ngIf="isRecorded"
          [disabled]="isActiveCoundown"
          class="play-btn"
        >
          <i
            *ngIf="!isPlaying"
            class="pi pi-play icon"
            style="color: #25afb5; margin-left: 2px"
          ></i>
          <i
            *ngIf="isPlaying"
            class="pi pi-pause icon"
            style="color: #25afb5"
          ></i>
        </button>
        <button
          (click)="saveVideoToServer() && (isSlowScroll = !isSlowScroll)"
          *ngIf="isRecorded"
          [disabled]="isActiveCoundown"
          class="save-btn button-simple primary-btn"
        >
          <span *ngIf="!isMobile">SAVE & NEXT</span>
          <span *ngIf="isMobile">Use Video</span>
        </button>
      </div>
      <div [ngClass]="{
      flex: !isMobile,
      'justify-content-center': !isMobile,
      'd-grid': isMobile,
      'justify-content-between': isMobile,
      'height100': isMobile,
      'mr-2': !isMobile,
      'm-auto': isMobile
      }" class=" align-items-center teleprompter-actions">
        <div *ngIf="isTeleprompter && !isMobile" class="action-container">
          <div class="flex align-items-baseline">
            <button (click)="changeTeleprompterFontSize('decrease')">-</button>
            <img width="31" height="24" ngSrc="assets/images/teleprompter/icon-size-text.svg" alt="">
            <button (click)="changeTeleprompterFontSize('increase')">+</button>
          </div>
          <span class="action-title">Text Size</span>
        </div>

        <div *ngIf="isTeleprompter" class="action-container">
          <div class="flex align-items-baseline">
            <button (click)="changeTeleprompterSpeed('decrease')">-</button>
            <div class="flex align-items-center">
              <button
                (click)="changeTeleprompterSpeed(!intervalScroll || intervalScroll?.closed ? 'play' : 'pause')">
                <img style="height: 25px"
                     height="30"
                     width="30"
                     [ngSrc]="!intervalScroll || intervalScroll?.closed
                      ? 'assets/images/icon-play.svg'
                      : 'assets/images/teleprompter/icon-pause.svg'"
                     alt="">
              </button>
            </div>
            <button (click)="changeTeleprompterSpeed('increase')">+</button>
          </div>
          <span class="action-title">Scroll Speed</span>
        </div>
        <span (click)="closeRecorder()" *ngIf="!isRecorded && isMobile" class="close-btn">Cancel</span>
      </div>
    </div>
  </div>
  <video #videoRecordedElement [ngClass]="{hidden: !isRecorded}" playsinline></video>
  <video #videoElement [ngClass]="{hidden: isRecorded}" [autoplay]="true" [muted]="true" playsinline></video>
  <div [class.showCountdown]="isActiveCoundown" class="count-down-to-start">
    {{ timerCountdown }}
  </div>
  <div
    id="userMessage"
    *ngIf="!isRecorded && !isRecording"
    class="user-message-rotate"
  >
    <div class="rotate-icon"></div>
  </div>
  <p-dialog
    [(visible)]="isModalError"
    [baseZIndex]="10000"
    [closable]="false"
    [style]="{ width: '50%', maxWidth: '300px', padding: '24px' }"
    header="Oops!"
  >
    <p class="p-m-0">{{ this.modalErrorText }}</p>
    <div class="footer flex justify-content-end">

        <button
                pButton
                type="button"
                class="button-simple primary-btn"
                (click)="initCamera()"
                *ngIf="isPermissionDenied"
        >
            Try again
        </button>
        <button
                pButton
                type="button"
                class="button-simple secondary-btn font-color-dark"
                (click)="closeRecorder()"
                *ngIf="isNotSupportedBrowser || isPermissionDenied"
        >
            Exit
        </button>
    </div>
  </p-dialog>
</div>
